export const toggleIsHidden = (elDimensionBottom: number, topOffset: number, el: HTMLDivElement) => {
    elDimensionBottom <= topOffset ? el.classList.add("isHidden") : el.classList.remove("isHidden");
}

export const updateCouponButtonPosition = (buttonElement: HTMLDivElement, parentElement: HTMLDivElement, topOffset: number) => {
    const parentDimensions = parentElement.getBoundingClientRect();
    const couponBtnDimensions = buttonElement.getBoundingClientRect();
    const leftOffsetFormula = parentDimensions.width + parentDimensions.left - couponBtnDimensions.width;
    const btnStyle = buttonElement.style;

    if (parentDimensions.top <= topOffset) {
        buttonElement.classList.add("rj-league-list__coupon-btn--fixed");
        btnStyle.top = topOffset + "px";
        btnStyle.left = leftOffsetFormula + "px";

        toggleIsHidden(parentDimensions.bottom, topOffset, buttonElement);
        return btnStyle;
    }

    buttonElement.removeAttribute("style");
    buttonElement.classList.remove("rj-league-list__coupon-btn--fixed");

    return btnStyle;
};